var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPajaroIconoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-282 -497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.377 514.013 317.867 514.248C317.323 513.817 316.217 513.225 314.312 513.269 311.762 513.347 310.552 515.164 308.232 517.225 306.323 512.931 302.788 508.226 299.625 505.715 299.304 505.463 298.839 505.519 298.587 505.84 298.492 505.961 298.437 506.109 298.43 506.263 298.419 508.426 298.656 510.582 299.135 512.691 302.073 514.463 304.741 516.608 306.249 518.826 305.99 519.007 305.711 519.188 305.422 519.364 302.518 515.208 294.812 510.806 289.456 509.695 289.056 509.614 288.666 509.872 288.585 510.273 288.555 510.419 288.571 510.571 288.629 510.708 290.142 514.077 294.602 519.707 298.763 522.87L286.651 534.923C286.489 535.101 286.503 535.377 286.681 535.539 286.806 535.652 286.985 535.683 287.141 535.618 290.607 533.787 296.712 530.913 301.637 530.429 311.101 529.499 316.325 523.79 318.112 515.55L325.397 514.253C325.462 514.235 325.5 514.168 325.483 514.103 325.47 514.054 325.428 514.018 325.377 514.013Z",
    fill: "#80C606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPajaroIconoHover);
export default __webpack_public_path__ + "static/media/pajaro-icono-hover.f9018c7f40d0eba61ea0b6b64c5fc4f0.svg";
export { ForwardRef as ReactComponent };